<script setup>
    import { useHead } from "#imports";

    useHead({
        script: [
            {
                id: "bitrix-script",
                innerHTML: `
                  (function(w,d,u){
                var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/60000|0);
                var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
        })(window,document,'https://cdn-ru.bitrix24.ru/b34372598/crm/site_button/loader_3_wstue3.js');
                `,
                type: "text/javascript"
            }
        ]
    });
</script>

<template>
  <NuxtLayout>
    <div>
      <NuxtLoadingIndicator />
      <!-- <LoaderOverlay /> -->
      <NuxtPage />
    </div>
  </NuxtLayout>
</template>